import { notification, Upload } from 'antd';
import { RcFile } from 'antd/es/upload/interface';
import { AnyObject, IBeforeUploadOptions } from 'interfaces';
import { MAX_FILE_SIZE } from 'constants/upload';
import { t } from 'helpers/i18n';
import { FileHelpers } from 'helpers';

const beforeUpload = (file: RcFile, options?: IBeforeUploadOptions) => {
  const accept = options?.accept;
  const acceptErrorMessage =
    options?.acceptErrorMessage || 'File đang tải lên không đúng định dạng';
  const size = options?.size || MAX_FILE_SIZE;
  const sizeErrorMessage =
    options?.sizeErrorMessage ||
    `File tải lên có dung lượng vượt quá ${size}MB`;

  if (!accept) return Upload.LIST_IGNORE;
  if (
    !accept
      .split(',')
      .some(s => s.includes(FileHelpers.getFileExtension(file.name)))
  ) {
    notification.error({
      message: t('Error'),
      description: acceptErrorMessage,
    });
    return Upload.LIST_IGNORE;
  }
  const sizeState = file.size / 1024 / 1024 < size;
  if (!sizeState) {
    notification.error({
      message: sizeErrorMessage,
    });
    return Upload.LIST_IGNORE;
  }
  return true;
};

const getListFileName = (files: AnyObject[]) => {
  return files && files.length >= 1
    ? files.map(file => {
        return file?.fileName || file?.response?.data?.fileName;
      })
    : [];
};

export default {
  beforeUpload,
  getListFileName,
};
